export enum EditMode {
  Create = 'create',
  Delete = 'delete',
  Update = 'update',
}
